"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _general = _interopRequireDefault(require("./general.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = function _default(props) {
  var bubbleMessages = props.settings.bubbleMessages;
  if (!bubbleMessages || bubbleMessages.filter(function (message) {
    return message.text;
  }).length === 0) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _general["default"].bubble
  }, bubbleMessages.map(function (message) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: message.id
    }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content: message.text
    }));
  }));
};